import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import * as R from 'ramda/src/index';
import Leg from './Leg';
import Modal from 'react-bootstrap/lib/Modal';
import ModalDetails from './Leg/ModalDetails';
import {Card} from 'components/card';
import {formatPrice} from 'lib/helpers/globalize-helper';

const NUMBER_OF_VISIBLE_PROVIDERS = 2;

const renderRestProviders = (openResultModal, providers) =>
  R.pipe(
    R.take(NUMBER_OF_VISIBLE_PROVIDERS),
    R.map((provider) => (
      <a key={provider.id} className="d-flex" onClick={openResultModal}>
        <span>{provider.provider.presentationName}</span>
        <span className="ml-auto">{formatPrice(provider.total)}</span>
      </a>
    ))
  )(providers);


class Result extends Component {
  state = {
    isResultModalOpen: false
  };

  toggleModal = () => {
    this.setState((prevState) => ({isResultModalOpen: !prevState.isResultModalOpen}));
  };

  render() {
    const {isResultModalOpen} = this.state;
    const {result, searchQuery, isTablet, loading, translations} = this.props;
    const {legs, providers, checkLastSeats} = result;
    const providersData = [...providers];
    const cheapestProvider = providersData.shift();
    const displayLastSeat = checkLastSeats <= 3;
    const {metaResults: {bookFor, showMoreDeals, select: selectTr, onPartner, moreDeals},
      lastSeat, lastSeats} = translations;
    const seatsLeftMsg = displayLastSeat && (checkLastSeats === 1) ? lastSeat : lastSeats;

    return (
      <Card className="card-hover">
        <div className="grid no-gutter">
          <div className="grid-item d-flex">
            <div className="segment-group">
              {
                legs.map((leg, index) =>
                  <Leg
                    key={index}
                    leg={leg}
                    translations={translations}
                    onClick={this.toggleModal}
                  />)
              }
            </div>
          </div>
          <div className="grid-item-md-1-4 d-flex">
            <div className="result-footer">
              {displayLastSeat &&
                <div className="text-danger text-small seat-left">{checkLastSeats} {seatsLeftMsg}</div>
              }
              {isTablet ?
                <div className="d-flex ml-auto order-1">
                  <div className="pr-2 text-right">
                    <div className="h3">{formatPrice(cheapestProvider.total)}</div>
                    {
                      (providersData.length > 0)
                        ? (
                          <a className="text-muted" onClick={this.toggleModal}>
                            {moreDeals.replace('{numberDeals}', providersData.length + 1)}
                          </a>
                        )
                        : (
                          <small className="text-muted">
                            {onPartner.replace('{partner}', cheapestProvider.provider.presentationName)}
                          </small>
                        )
                    }
                  </div>
                  <button onClick={this.toggleModal} className="btn btn-primary">
                    {selectTr}
                  </button>
                </div>
                :
                <button
                  className="btn btn-primary btn-block leading-none py-1"
                  onClick={this.toggleModal}
                >
                  <span className="d-block font-normal">{bookFor}</span>
                  <span className="h3">{formatPrice(cheapestProvider.total)}</span>
                </button>
              }
              <small className="text-muted text-center d-none d-md-block mb-2">
                {onPartner.replace('{partner}', cheapestProvider.provider.presentationName)}
              </small>
              {loading && <div className="loading-spinner mx-md-auto"/>}
              {!isTablet &&
              <div className="mt-auto text-small w-1-1">
                {renderRestProviders(this.toggleModal, providersData)}
                {
                  providersData.length > NUMBER_OF_VISIBLE_PROVIDERS &&
                    <a
                      className="d-block mt-2"
                      onClick={this.toggleModal}
                    >
                      {showMoreDeals} ({providersData.length - NUMBER_OF_VISIBLE_PROVIDERS})
                    </a>
                }
              </div>
              }
            </div>
          </div>
        </div>
        {
          <Modal
            show={isResultModalOpen}
            onHide={this.toggleModal}
          >
            <ModalDetails
              checkLastSeats={checkLastSeats}
              legs={legs}
              closeResultModal={this.toggleModal}
              providers={providers}
              searchQuery={searchQuery}
              translations={translations}
            />
          </Modal>
        }
      </Card>
    );
  }
}

Result.propTypes = {
  loading: PropTypes.bool.isRequired,
  isTablet: PropTypes.bool.isRequired,
  result: PropTypes.object.isRequired,
  searchQuery: PropTypes.object.isRequired,
  translations: PropTypes.object.isRequired
};

export default observer(Result);
